/**
 * x-scroll-hint directive.
 *
 * Alpine directive that fades a hint overlay at the top and/or bottom edge
 * of a scrollable container to indicate there is more content to scroll to.
 * Each hint hides itself once its matching sentinel element scrolls into
 * view, i.e. once the container reaches that true edge.
 *
 * @markup
 *   <div x-scroll-hint class="overflow-auto">
 *     <div data-scroll-hint="top"></div>
 *     <div data-scroll-hint-sentinel="top"></div>
 *
 *     …scrollable content…
 *
 *     <div data-scroll-hint-sentinel="bottom"></div>
 *     <div data-scroll-hint="bottom"></div>
 *   </div>
 *
 * @example
 *   Used on .swatch-kit-sidebar-body in sections/main-swatch-kit-form.liquid.
 */
(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.directive("scroll-hint", (el, {}, { cleanup }) => {
      const hints = {
        top: el.querySelector('[data-scroll-hint="top"]'),
        bottom: el.querySelector('[data-scroll-hint="bottom"]'),
      };

      const sentinels = {
        top: el.querySelector('[data-scroll-hint-sentinel="top"]'),
        bottom: el.querySelector('[data-scroll-hint-sentinel="bottom"]'),
      };

      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const edge = entry.target === sentinels.top ? "top" : "bottom";
            hints[edge]?.classList.toggle("is-hidden", entry.isIntersecting);
          }
        },
        { root: el },
      );

      if (sentinels.top) io.observe(sentinels.top);
      if (sentinels.bottom) io.observe(sentinels.bottom);

      cleanup(() => io.disconnect());
    });
  });
})();
